import type { VueConstructor } from 'vue';

import LoaderComponent from './loader.vue';

const Loader = {
  install(Vue: VueConstructor) {
    Vue.component(LoaderComponent.name, LoaderComponent);
  }
};

export default Loader;
